const state = {
    form: {
        // application_date_era: null, // 申込日(元号) ※デフォルトで本日の日付
        application_date_year: null, // 申込日(年) ※デフォルトで本日の日付
        application_date_month: null, // 申込日(月) ※デフォルトで本日の日付
        application_date_day: null, // 申込日(日) ※デフォルトで本日の日付
        purpose_of_transaction: '生計費決済', // 取引を行う目的 ※デフォルトで「1:生計費決済」
        purpose_of_transaction_other_name: null, // 取引を行う目(その他）
        is_foreign_government: 'いいえ',
        foreign_government_company: null,
        surname: null, // 姓
        first_name: null, // 名
        old_surname: null, // 旧姓
        surname_kana: null, // 姓(フリガナ)
        first_name_kana: null, // 名(フリガナ)
        old_surname_kana: null, // 旧姓(カナ)
        sex_type: 2, // 性別 ※デフォルトで「2:女性」
        // birthday_era: '平成', // 元号 ※デフォルトで「平成」
        birthday_year: null, // 生年月日(年)
        birthday_month: null, // 生年月日(月)
        birthday_day: null, // 生年月日(日)
        post_number: null, // 郵便番号
        street_address1: null, // 住所1
        street_address2: null, // 住所2
        street_address_kana: null, // 住所カナ(住所1のカナ)
        fixed_phone1: null, // 固定電話
        fixed_phone2: null, // 固定電話
        fixed_phone3: null, // 固定電話
        mobile_phone1: null, // 携帯電話
        mobile_phone2: null, // 携帯電話
        mobile_phone3: null, // 携帯電話
        // has_spouse: null, // 配偶者有無
        // parent_living: null, // 親同居有無
        // child_status: null, // 子供有無
        // child_number: null, // 子供人数
        // others_status: null, // その他有無
        // others_number: null, // その他人数
        family_about: null, // ご家族について
        family_about_number: null, // ご家族についての同居人数
        family_structure: null, // 生計同一人数
        residence_classification: null, // 住居形態
        residence_period_year: null, // 居住年数(年)
        // residence_period_month: null, // 居住年数(月)
        loan_rent: null, // ローン有無
        householder_relation: '本人', // 世帯主との関係 ※デフォルトは「本人」
        householder_income: null, // 世帯主収入
        householder_income_type: null, // 世帯主の所得種類
        householder_income_type_other_name: null, // 世帯主の所得種類 その他の場合のテキスト
        householder_monthly_credit_payments: null, // 世帯主のクレジット月間支払い額
        parents_post: null, // 実家郵便番号
        parents_address: null, // 実家住所
        parents_phone1: null, // 実家電話番号
        parents_phone2: null, // 実家電話番号
        parents_phone3: null, // 実家電話番号
        parents_phone_exists: false,  // 実家固定電話の入力有無
        parents_mobile_phone1: null, // 実家携帯電話番号
        parents_mobile_phone2: null, // 実家携帯電話番号
        parents_mobile_phone3: null, // 実家携帯電話番号
        parents_mobile_exists: false,  // 実家携帯電話の入力有無
        parents_phone_relationship: null,  // 実家携帯電話の続柄
        parents_phone_relationship_other_name: null, // 実家携帯電話の続柄(その他)
        occupation: null, // お勤め先・学校について
        occupation_other_name: null, // お勤め先・学校について　その他の場合のテキスト
        student_unemployed_flg: false, // （※自社割賦限定）「アルバイトをされていない方はチェックを入れて下さい。」のチェック
        // employment_status: null, // 就業形態
        // employment_status_other_name: null, // 就業形態 その他の場合のテキスト
        graduate_year: null, // 卒業予定(年)
        graduate_month: null, // 卒業予定(月)
        company_name: null, // お勤め先
        company_name_kana: null, // お勤め先カナ
        company_phone1: null, // お勤め先電話番号
        company_phone2: null, // お勤め先電話番号
        company_phone3: null, // お勤め先電話番号
        company_job_description: null, // 仕事内容
        company_job_description_other_name: null, // 仕事内容 その他の場合のテキスト
        job_department: null, // 所属部課
        dispatched_agent: null, // 出向派遣元
        company_post: null, // 勤め先郵便番号
        company_address: null, // 勤め先住所
        join_year: null, // 入社年月(年)
        join_month: null, // 入社年月(月)
        payday: null, // 給料日
        company_income: null, // 税込年収
        sideline_type: null, // その他収入
        sideline_other_name: null, // その他収入 その他の場合のテキスト
        sideline_income: null, // その他収入(年額)
        comapny_employees_number: null, // 勤め先社員数
        bank_deposit: null, // 預金額
        spouse_income: null, // 配偶者の年収
        is_change_customer: 0, // 変更届フラグ
        contract_documents: [], // エステ契約書保存用
    },
    init: {
        // application_date_era: null, // 申込日(元号) ※デフォルトで本日の日付
        application_date_year: null, // 申込日(年) ※デフォルトで本日の日付
        application_date_month: null, // 申込日(月) ※デフォルトで本日の日付
        application_date_day: null, // 申込日(日) ※デフォルトで本日の日付
        purpose_of_transaction: '生計費決済', // 取引を行う目的 ※デフォルトで「1:生計費決済」
        purpose_of_transaction_other_name: null, // 取引を行う目(その他）
        is_foreign_government: 'いいえ',
        foreign_government_company: null,
        surname: null, // 姓
        first_name: null, // 名
        surname_kana: null, // 姓(フリガナ)
        first_name_kana: null, // 名(フリガナ)
        sex_type: 2, // 性別 ※デフォルトで「2:女性」
        // birthday_era: '平成', // 元号 ※デフォルトで「平成」
        birthday_year: null, // 生年月日(年)
        birthday_month: null, // 生年月日(月)
        birthday_day: null, // 生年月日(日)
        post_number: null, // 郵便番号
        street_address1: null, // 住所1
        street_address2: null, // 住所2
        street_address_kana: null, // 住所カナ(住所1のカナ)
        fixed_phone1: null, // 固定電話
        fixed_phone2: null, // 固定電話
        fixed_phone3: null, // 固定電話
        mobile_phone1: null, // 携帯電話
        mobile_phone2: null, // 携帯電話
        mobile_phone3: null, // 携帯電話
        // has_spouse: null, // 配偶者有無
        // parent_living: null, // 親同居有無
        // child_status: null, // 子供有無
        // child_number: null, // 子供人数
        // others_status: null, // その他有無
        // others_number: null, // その他人数
        family_about: null, // ご家族について
        family_about_number: null, // ご家族についての同居人数
        family_structure: null, // 生計同一人数
        residence_classification: null, // 住居形態
        residence_period_year: null, // 居住年数(年)
        // residence_period_month: null, // 居住年数(月)
        loan_rent: null, // ローン有無
        householder_relation: '本人', // 世帯主との関係 ※デフォルトは「本人」
        householder_income: null, // 世帯主収入
        householder_income_type: null, // 世帯主の所得種類
        householder_income_type_other_name: null, // 世帯主の所得種類 その他の場合のテキスト
        householder_monthly_credit_payments: null, // 世帯主のクレジット月間支払い額
        parents_post: null, // 実家郵便番号
        parents_address: null, // 実家住所
        parents_phone1: null, // 実家電話番号
        parents_phone2: null, // 実家電話番号
        parents_phone3: null, // 実家電話番号
        parents_phone_exists: false,  // 実家固定電話の入力有無
        parents_mobile_phone1: null, // 実家携帯電話番号
        parents_mobile_phone2: null, // 実家携帯電話番号
        parents_mobile_phone3: null, // 実家携帯電話番号
        parents_mobile_exists: false,  // 実家携帯電話の入力有無
        parents_phone_relationship: null,  // 実家携帯電話の続柄
        parents_phone_relationship_other_name: null, // 実家携帯電話の続柄(その他)
        occupation: null, // お勤め先・学校について
        occupation_other_name: null, // お勤め先・学校について　その他の場合のテキスト
        student_unemployed_flg: false, // （※自社割賦限定）「アルバイトをされていない方はチェックを入れて下さい。」のチェック
        // employment_status: null, // 就業形態
        // employment_status_other_name: null, // 就業形態 その他の場合のテキスト
        graduate_year: null, // 卒業予定(年)
        graduate_month: null, // 卒業予定(月)
        company_name: null, // お勤め先
        company_name_kana: null, // お勤め先カナ
        company_phone1: null, // お勤め先電話番号
        company_phone2: null, // お勤め先電話番号
        company_phone3: null, // お勤め先電話番号
        company_job_description: null, // 仕事内容
        company_job_description_other_name: null, // 仕事内容 その他の場合のテキスト
        job_department: null, // 所属部課
        dispatched_agent: null, // 出向派遣元
        company_post: null, // 勤め先郵便番号
        company_address: null, // 勤め先住所
        join_year: null, // 入社年月(年)
        join_month: null, // 入社年月(月)
        payday: null, // 給料日
        company_income: null, // 税込年収
        sideline_type: null, // その他収入
        sideline_other_name: null, // その他収入 その他の場合のテキスト
        sideline_income: null, // その他収入(年額)
        comapny_employees_number: null, // 勤め先社員数
        bank_deposit: null, // 預金額
        spouse_income: null, // 配偶者の年収
        is_change_customer: 0, // 変更届フラグ
        contract_documents: []
    },
    validations: [] // php側のバリデーション
}

const getters = {
    // formの値を取得
    getForm(state) {
        return state.form
    },
    getValidations(state) {
        return state.validations
    }
}

const mutations = {
    setForm(state, form) {
        state.form = form
    },
    // php側のバリデーションエラー更新
    updateValidations(state, validations) {
        state.validations = validations
    }
}

const actions = {
    // formの値をセット
    setForm({ commit }, form) {
        commit('setForm', form)
    },
    initForm({ commit, state }) {
        commit('setForm', state.init)
    },
    // php側のバリデーションエラー更新
    updateValidations({ commit }, validations) {
        commit('updateValidations', validations)
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}